import { FilterType } from './../enum/FilterType';
import { useEffect } from 'react';
import { setFilterType } from '../store/slice/global-filters';
import { useAppDispatch } from './useAppDispatch';

const useSetHeaderFilterType = (filterType: FilterType | undefined) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setFilterType(filterType));
  }, [dispatch, filterType]);
};

export default useSetHeaderFilterType;
